var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWaist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.53,25.83h10.02c.28-2.33,2.27-4.1,4.62-4.1h11.8c2.35,0,4.34,1.77,4.62,4.1h19.89c.72,0,1.31,.59,1.31,1.31v14.6c0,.72-.59,1.31-1.31,1.31h-19.89c-.28,2.33-2.27,4.1-4.62,4.1h-11.8c-2.35,0-4.34-1.77-4.62-4.1H6.53c-.72,0-1.31-.59-1.31-1.31v-14.6c0-.73,.59-1.31,1.31-1.31Zm45.89,9.25c0,1.73-2.63,1.73-2.63,0v-1.27c0-1.73,2.63-1.73,2.63,0v1.27Zm-8.21,0c0,1.73-2.63,1.73-2.63,0v-1.27c0-1.73,2.63-1.73,2.63,0v1.27Zm-31.06,.68c-1.73,0-1.73-2.63,0-2.63h3.37v-4.67H7.84v11.97h8.67v-4.67h-3.37Zm6-2.62h2.32c1.73,0,1.73,2.63,0,2.63h-2.32v6.75c0,1.11,.91,2.02,2.02,2.02h11.8c1.11,0,2.02-.91,2.02-2.02V26.38c0-1.11-.91-2.02-2.02-2.02h-11.8c-1.11,0-2.02,.91-2.02,2.02v6.75h0Zm37.02-4.67h-18.55v11.97h18.55v-11.97Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWaist);
export default __webpack_public_path__ + "static/media/icon_waist.e9056e09.svg";
export { ForwardRef as ReactComponent };